<template>
  <div
    class="header-avatar"
  >
    <popover
      placement="bottom"
      transition
      :width="304"
      :offset="12"
      v-model:visible="visiblePopover"
    >
      <template #reference>
        <div class="popover-container">
          <div class="hello-message">
            <span class="hello">
              {{ $t('User.Hello') }}
            </span>
            <span class="full-name">
              {{ firstName }}
            </span>
          </div>
          <img
            ref="image"
            class="image"
            :src="avatar"
            @error="loadDefault()"
          >
        </div>
      </template>
      <user-popover v-model:visible="visiblePopover" />
    </popover>
  </div>
</template>

<script>
import Popover from '@/components/popover'
import { getContextData, ContextDataKey } from '@/utils/context-data'
import UserPopover from './user-popover'

export default {
  name: 'AppHeaderUser',

  components: {
    Popover,
    UserPopover
  },

  data () {
    return {
      visiblePopover: false,
      avatar: getContextData(ContextDataKey.Image)
    }
  },

  computed: {
    // Tên giáo viên
    firstName () {
      return getContextData(ContextDataKey.FirstName)
    }
  },

  methods: {
    loadDefault () {
      this.$refs.image.src = require('@/assets/images/svg/avatar/student/default/default.svg')
    }
  }
}
</script>

<style lang="scss" scoped>
.header-avatar {
  top: 0;
  right: 0;
  height: 100%;
  width: auto;
  padding-right: 16px;
  display: flex;
  align-items: center;
  cursor: pointer;

  .popover-container {
    display: flex;

    .hello-message {
      margin: auto 16px auto 8px;

      .full-name {
        @include font-bold();
      }
    }

    .image {
      height: 47px;
      width: 47px;
      background-size: 100%;
      background-repeat: none;
      background-color: $color-neutral-light-1;
      border: 1px solid $color-neutral-light-1;
      border-radius: 50%;
      cursor: pointer;
      overflow: hidden;
    }
  }
}
</style>
